import { css } from '@emotion/react';
import type { ReactElement, ReactNode } from 'react';

import { styled } from '../../../../styled';

type Interface = { className: string; children: ReactNode };

const Component = ({ className, children }: Interface): ReactElement => <div className={className}>{children}</div>;

export const AgentInfo = styled(Component)(
	css`
		align-items: center;
		display: flex;
		width: 100%;
	`
);
